import disciplinarySubType from '@/api/disciplinary-sub-type'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  disciplinaryTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DISCIPLINARY_TYPES(state, data) {
    state.disciplinaryTypes = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return disciplinarySubType.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return disciplinarySubType.store(data)
  },

  async find(context, id) {
    return await disciplinarySubType.find(id)
  },

  update(context, data) {
    return disciplinarySubType.update(data)
  },

  delete(context, data) {
    return disciplinarySubType.destroy(data)
  },
  getAttStatus(context, data) {
    return disciplinarySubType.attStatus(data)
  },
  async dataBeforeCreate(context) {
    if (!context.state.disciplinaryTypes.length > 0) {
      let response = await disciplinarySubType.disciplinaryType()
      context.commit('SET_DISCIPLINARY_TYPES', response)
    }
  }
}
